import { INPATIENT_TYPE } from "$routes/_lib/constants";
import dayjs from "$routes/_lib/dayjs";
import { Box, makeStyles, Typography } from "@material-ui/core";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";

function isInpatient(type = "outpatient") {
  return type.toUpperCase() === INPATIENT_TYPE.toUpperCase();
}

const useStyles = makeStyles((theme) => ({
  paragraph: {
    fontSize: 14,
    marginBottom: theme.spacing(0.5),
  },
  paragraphTitle: {
    fontSize: 16,
    marginBottom: theme.spacing(2),
  },
}));

const PatientDetails = ({ invoice }) => {
  const { patientType, inpatientDetails, patient } = invoice;
  const {
    person: {
      name: { firstname, lastname },
      dob,
    },
  } = patient;
  const classes = useStyles();

  const { admission, inpatientNumber, discharge, ward } =
    inpatientDetails || {};
  const dobFormatted = dayjs(dob).format("DD/MM/YYYY");
  // Date is not currently in UTC, so casting it to local time so it is the expected time for Kenya:
  const admissionDateFormatted = dayjs(new Date(admission)).format(
    "DD/MM/YYYY",
  );
  const dischargeDateFormatted = dayjs(new Date(discharge)).format(
    "DD/MM/YYYY",
  );
  const cardId = patient.cardId || patient?.passport?.uid;

  return (
    <Box mt={2} mb={2}>
      <Typography className={classes.paragraphTitle}>
        <strong>{`${firstname} ${lastname}`}</strong>
      </Typography>
      {cardId && (
        <Typography className={classes.paragraph}>
          <strong>
            <FormattedMessage
              id="printableInvoice.patient.id"
              defaultMessage="Patient ID:"
            />
          </strong>
          {` ${cardId}`}
        </Typography>
      )}
      <Typography className={classes.paragraph}>
        <strong>
          <FormattedMessage
            id="printableInvoice.patient.dob"
            defaultMessage="D.O.B:"
          />
        </strong>
        {` ${dobFormatted}`}
      </Typography>
      {isInpatient(patientType) && (
        <>
          <Typography className={classes.paragraph}>
            <strong>
              <FormattedMessage
                id="printableInvoice.patient.inpatient.number"
                defaultMessage="Inpatient no.:"
              />
            </strong>
            {` ${inpatientNumber ?? "N/a"}`}
          </Typography>
          <Typography className={classes.paragraph}>
            <strong>
              <FormattedMessage
                id="printableInvoice.patient.inpatient.ward"
                defaultMessage="Ward:"
              />
            </strong>
            {` ${ward ?? "N/a"}`}
          </Typography>
          <Typography className={classes.paragraph}>
            <strong>
              <FormattedMessage
                id="printableInvoice.patient.inpatient.admissionDate"
                defaultMessage="Date admitted:"
              />
            </strong>
            {` ${admissionDateFormatted}`}
          </Typography>
          {discharge ? (
            <Typography className={classes.paragraph}>
              <strong>
                <FormattedMessage
                  id="printableInvoice.patient.inpatient.dischargeDate"
                  defaultMessage="Date discharged:"
                />
              </strong>
              {` ${dischargeDateFormatted}`}
            </Typography>
          ) : null}
        </>
      )}
    </Box>
  );
};

PatientDetails.propTypes = {
  invoice: PropTypes.shape({
    _id: PropTypes.string.isRequired,
    patientType: PropTypes.string.isRequired,
    invoiceStatus: PropTypes.string.isRequired,
    patient: PropTypes.shape({
      person: PropTypes.shape({
        name: PropTypes.shape({
          firstname: PropTypes.string,
          lastname: PropTypes.string,
        }),
        dob: PropTypes.string,
      }),
      cardId: PropTypes.string,
      passport: PropTypes.string,
    }).isRequired,
    inpatientDetails: PropTypes.shape({}).isRequired,
  }).isRequired,
};

export default PatientDetails;
